module.exports = __webpack_public_path__ + "img/New PACI Flow - New-2.2e292e6e.png";